import { Child, UpdateChild } from '../models';
import { mapFromParentDto } from '../../parent';
import { ChildDto, UpdateChildDto } from '../dto';

export function mapFromChildDto(dto: ChildDto): Child {
  return {
    id: dto.id ?? null,
    name: dto.name ?? null,
    status: dto.status ?? null,
    securityStatus: dto.security_status ?? null,
    gender: dto.gender ?? null,
    customGender: dto.custom_gender ?? null,
    avatar: dto.avatar ?? null,
    customAvatarUrl: dto.custom_avatar_url ?? null,
    age: dto.age ?? null,
    emergencyContactName: dto.emergency_contact?.name ?? null,
    emergencyContactPhoneCode: dto.emergency_contact?.phone_code ?? null,
    emergencyContactPhoneNumber: dto.emergency_contact?.phone_number ?? null,
    createdAt: dto.created_at ?? null,
    updatedAt: dto.updated_at ?? null,
    familyMembers: {
      childUsers: dto.family_members?.child_users?.map((childDto) => mapFromChildDto(childDto)) ?? [],
      parentUsers: dto.family_members?.parent_users?.map((parentDto) => mapFromParentDto(parentDto)) ?? [],
    },
  };
}

export function mapUpdateChildToDto(child: UpdateChild): UpdateChildDto {
  return {
    name: child.name ?? null,
    age: child.age ?? null,
    emergency_contact: {
      name: child.emergencyContactName ?? null,
      phone_code: child.emergencyContactPhoneCode ?? null,
      phone_number: child.emergencyContactPhoneNumber ?? null,
    },
  };
}

export function mapFromChildToUpdateChild(child: Child): UpdateChild {
  return {
    name: child.name ?? null,
    age: child.age ?? null,
    emergencyContactName: child.emergencyContactName ?? null,
    emergencyContactPhoneCode: child.emergencyContactPhoneCode ?? null,
    emergencyContactPhoneNumber: child.emergencyContactPhoneNumber ?? null,
  };
}
